var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttentionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3.23077C11.1863 3.23077 3.23077 11.1863 3.23077 21C3.23077 30.8137 11.1863 38.7691 21 38.7691C30.8137 38.7691 38.7691 30.8137 38.7691 21C38.7691 11.1863 30.8137 3.23077 21 3.23077ZM0 21C0 9.40201 9.40201 0 21 0C32.5979 0 42 9.40201 42 21C42 32.5979 32.5979 42 21 42C9.40201 42 0 32.5979 0 21Z",
    fill: "#C03658"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0001 11.8462C21.8922 11.8462 22.6154 12.5694 22.6154 13.4616V22.0769C22.6154 22.9692 21.8922 23.6924 21.0001 23.6924C20.108 23.6924 19.3848 22.9692 19.3848 22.0769V13.4616C19.3848 12.5694 20.108 11.8462 21.0001 11.8462Z",
    fill: "#C03658"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1513 28.5383C23.1513 29.7279 22.187 30.6923 20.9975 30.6923C19.8081 30.6923 18.8438 29.7279 18.8438 28.5383C18.8438 27.3488 19.8081 26.3845 20.9975 26.3845C22.187 26.3845 23.1513 27.3488 23.1513 28.5383Z",
    fill: "#C03658"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttentionIcon);
export default __webpack_public_path__ + "static/media/attention-icon.8189d35b3c6a732e66e31633be56cbfe.svg";
export { ForwardRef as ReactComponent };